<template>
  <v-dialog v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }">
    <v-card class="confirm-modal">
      <v-card-title>
        {{ options.title || $t('views.core.confirm.titleDefault') }}
      </v-card-title>
      <v-card-text class="pt-4">
        <p class="message ma-0" :class="{ 'white--text': $vuetify.theme.dark }">
          {{ options.message || $t('views.core.confirm.messageDefault') }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn class="mx-0" text @click.native="cancel">
          {{ options.rejectText || $t('views.core.confirm.cancelDefault') }}
        </v-btn>
        <v-btn class="ml-2 mr-2" :color="options.okColor || 'error'" @click.native="agree">
          {{ options.resolveText || $t('views.core.confirm.okDefault') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    options: {},
  }),
  methods: {
    open(options) {
      this.dialog = true
      this.options = Object.assign(
        {
          width: 350,
          zIndex: 200,
          title: null,
          message: null,
          resolveText: null,
          rejectText: null,
          okColor: null,
        },
        options
      )
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      this.resolve(true)
      this.dialog = false
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
    },
  },
}
</script>

<style lang="scss">
.confirm-modal {
  .message {
    font-size: 14px;
    line-height: 1.5;
    text-align: justify;
  }
}
</style>
